import { render } from "./DynamicModal.vue?vue&type=template&id=979998d2"
import script from "./DynamicModal.vue?vue&type=script&lang=js"
export * from "./DynamicModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../SINTEZ/store/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__